import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  console.log("data in data", fetchData);

  const data = fetchData;
  // console.log("checking data in product", fetchData);

  const formattedData = useMemo(() => {
    const rows = [];

    if (data && Array.isArray(data)) {
      data.forEach((item, index) => {
        const row = {
          id: item.id,
          table_name: item.table_name,
          username: item.username,
          type: item.type,
          created_at: item.created_at,
        };

        rows.push(row);
      });
    }

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
